export const normalizeEntityTypeKey = (value) =>
  String(value || '')
    .trim()
    .toLowerCase();

export const createEntityTypeMap = (entityTypes = []) => {
  const entityTypeMap = new Map();

  entityTypes.forEach((entityType) => {
    const valueKey = normalizeEntityTypeKey(entityType?.value);
    const labelKey = normalizeEntityTypeKey(entityType?.label);

    if (valueKey) {
      entityTypeMap.set(valueKey, entityType);
    }
    if (labelKey) {
      entityTypeMap.set(labelKey, entityType);
    }
  });

  return entityTypeMap;
};
